import * as yup from "yup";
import { t } from "i18next";

export const getReferenceTableSchema = (fields: string[]) => {
  const shape: Record<string, any> = {};

  fields.forEach((field) => {
    shape[field] = yup.mixed().required(
      field === "name"
        ? t("admin.reference.table.name-required")
        : t("admin.reference.table.field-required", { field })
    );
  });

  return yup.object().shape(shape);
};
